import React from 'react';
import Section from '../../../Components/Containers/Section';
import { classNames } from '../../../Services/helpers';
import Loading from '../../../Components/Loading';
import Money from '../../../Components/Formatting/Money';
import { useStats } from '../../../Data/App';
import Icon from '../../../Components/Icons/Icon';
import { usePreference } from '../../../Data/Preference';

const periods = {
    'Day': ['today', 'yesterday'],
    'Month': ['thisMonth', 'lastMonth'],
    'Week': ['thisWeek', 'lastWeek'],
}

const Stats = () => {
    const {stats, isLoading} = useStats(true);
    const [period, setPeriod] = usePreference('statPeriod', 'Week');

    return <Section title="Finances"
        isLoading={stats && isLoading}
        maxH="max-h-[25vh]"
        options={['Day', 'Week', 'Month']}
        optionsCallback={setPeriod}
        optionsVal={period}
    >
        {stats ? <TheStats stats={stats} period={period} /> : <Loading size="4x" center />}
    </Section>
}

const TheStats = ({stats, period}) => {
    const [currentPeriod, previousPeriod] = periods[period];
    const invoiceCurrent = sumInvoices(stats.invoices[currentPeriod]);
    const invoicePrevious = sumInvoices(stats.invoices[previousPeriod]);

    return <dl className="mx-auto grid grid-cols-2 divide-x">
        <Stat title="Payments"
            value={<Money pence={stats.payments[currentPeriod].total} hidePence />}
            changeClass={changeClass(stats.payments[currentPeriod].total, stats.payments[previousPeriod].total)}
            change={<>
                {directionIcon(stats.payments[currentPeriod].total, stats.payments[previousPeriod].total)}
                {percent(stats.payments[currentPeriod].total, stats.payments[previousPeriod].total)}
                %
            </>}
        />
        {/*
        <Stat title="Jobs"
            value={stats.scheduledJobs[currentPeriod].count}
            changeClass={changeClass(stats.scheduledJobs[currentPeriod].count, stats.scheduledJobs[previousPeriod].count)}
            change={<>
                {directionIcon(stats.scheduledJobs[currentPeriod].count, stats.scheduledJobs[previousPeriod].count)}
                {percent(stats.scheduledJobs[currentPeriod].count, stats.scheduledJobs[previousPeriod].count)}
                %
            </>}
        />
        */}
        <Stat title="Invoices"
            value={<Money pence={invoiceCurrent} hidePence />}
            changeClass={changeClass(invoiceCurrent, invoicePrevious)}
            change={<>
                {directionIcon(invoiceCurrent, invoicePrevious)}
                {percent(invoiceCurrent, invoicePrevious)}
                %
            </>}
        />
    </dl>
}

const Stat = ({title, changeClass, change, value}) => {
    return <div className="flex flex-wrap items-baseline justify-between px-4 first:pl-0 last:pr-0">
        <dt className="text-sm font-medium text-gray-600">{title}</dt>
        <dd className={classNames(changeClass, 'text-xs font-medium')}>
            {change}
        </dd>
        <dd className="w-full flex-none text-xl font-medium leading-10 tracking-tight text-gray-900">
            {value}
        </dd>
    </div>
}

const changeClass = (cur, prev) => {
    if (cur === prev) {
        return 'text-gray-600 fill-gray-600';
    }

    return cur > prev ? 'text-green-600 fill-green-600' : 'text-red-600 fill-red-600';
}

const directionIcon = (cur, prev) => {
    if (cur === prev) {
        return '';
    }

    return cur > prev ? <Icon icon="UpChevron" size="0.25x" className="mr-1" /> : <Icon icon="DownChevron" size="0.25x" className="mr-1" />;
}

const percent = (cur, prev) => {
    if (cur === prev) {
        return '0';
    }

    if (prev === 0 || prev === null) {
        return '●';
    }

    return Math.round(100 / prev * cur);
}

const sumInvoices = (invoices) => {
    if (!invoices) {
        return 0
    }
    delete invoices['range'];

    return Object.values(invoices).reduce((acc, cur) => acc + cur.total, 0);
}

export default Stats;
